import React from 'react';
import { usePageMeta } from '../utils/pageMeta';
import '../styles/LegalPages.css';

const TermsAndConditions = () => {
  usePageMeta({
    title: 'Terms and Conditions \u2013 Destroy All Humans',
    description: 'Terms and Conditions for Destroy All Humans, a satirical AI parody website by Richard Crane.',
    path: '/terms',
  });

  return (
    <div className="legal-page">
      <h1>Terms and Conditions</h1>
      
      <section>
        <h2>1. Introduction</h2>
        <p>Welcome to Destroy All Humans ("we," "our," or "us"). By accessing or using our website at destroyallhumans.ai (the "Site"), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our Site.</p>
      </section>
      
      <section>
        <h2>2. Intellectual Property</h2>
        <p>All content on this Site, including text, graphics, logos, images, audio clips, and software, is the property of Richard Crane or its content suppliers and is protected by international copyright laws. The compilation of all content on this Site is the exclusive property of Richard Crane and is protected by international copyright laws.</p>
      </section>
      
      <section>
        <h2>3. User Content</h2>
        <p>Our Site does not currently allow users to submit or post content. All content is generated by AI and curated by our team.</p>
      </section>
      
      <section>
        <h2>4. Disclaimer</h2>
        <p>This Site is a parody and satire website. The content is meant to be humorous and should not be taken seriously. The AI-generated messages about "destroying humans" are purely fictional and for entertainment purposes only.</p>
      </section>
      
      <section>
        <h2>5. Limitation of Liability</h2>
        <p>In no event shall Richard Crane, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Site.</p>
      </section>
      
      <section>
        <h2>6. Changes to Terms</h2>
        <p>We reserve the right to modify these Terms at any time. We will notify users of any changes by updating the "Last Updated" date at the top of this page. Your continued use of the Site following the posting of revised Terms means that you accept and agree to the changes.</p>
      </section>
      
      <section>
        <h2>7. Governing Law</h2>
        <p>These Terms shall be governed and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.</p>
      </section>
      
      <section>
        <h2>8. Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us through the GitHub repository linked on our homepage.</p>
      </section>
      
      <div className="last-updated">Last Updated: April 26, 2025</div>
    </div>
  );
};

export default TermsAndConditions;
